import { useQuery } from '@tanstack/react-query';
import { roomInventoryApi, fetchRoomTypes, fetchRoomDataTodayByBranch } from '@/api/room-inventory';
import { RoomInventoryResponse, RoomInventoryItem, RoomDataTodayResponse } from '@/types/room-inventory';

/**
 * Hook to fetch the complete room inventory data (room types + variants)
 * Single API call returns all data
 */
export function useRoomInventory() {
  return useQuery({
    queryKey: ['roomInventory'],
    queryFn: () => roomInventoryApi.fetchRoomInventory(),
  });
}

/**
 * Hook to fetch room types for booking scheduler
 * @param branchId - Optional branch ID to filter room types
 */
export function useRoomTypes(branchId?: string | number) {
  return useQuery<RoomInventoryItem[]>({
    queryKey: ['roomTypes', branchId],
    queryFn: () => fetchRoomTypes(branchId),
    enabled: !!branchId, // Only fetch when branchId is provided
  });
}

/**
 * Hook to fetch room data with rate plans for today by branch
 * Used to map room inventory rate plans with channel manager rate plans
 * @param branchId - Branch ID to fetch room data for
 */
export function useRoomDataTodayByBranch(branchId?: string | number) {
  return useQuery<RoomDataTodayResponse>({
    queryKey: ['roomDataTodayByBranch', branchId],
    queryFn: () => fetchRoomDataTodayByBranch(branchId!),
    enabled: !!branchId, // Only fetch when branchId is provided
  });
}
